import React from "react";
import ProfileAvatar from "Components/Fragment/ProfileAvatar";
import MediaQuery from "react-responsive";
import {
  StyledDesktopUserInfo,
  StyledMobileUserInfo,
  StyledMobileUserInfoHeader,
} from "./style";

const UserInfoHeading = (props) => {
  const { personalId, name, jobPositions, homeUnit } = props.userData;

  const { pageTitle } = props;

  const haveHomeUnit = typeof homeUnit !== "undefined" && homeUnit.id !== 0;

  return (
    <div>
      <MediaQuery minWidth={720}>
        <StyledDesktopUserInfo>
          <ProfileAvatar personalId={personalId} title={name} size="small" />
          <div className="column flex-center">
            <h1 className="page-header flex-wrap ">
              {`${pageTitle} - ${name} `}
            </h1>
            <Subtitle
              title={haveHomeUnit ? homeUnit.title : ""}
              positions={jobPositions ? jobPositions : ""}
            />
          </div>
        </StyledDesktopUserInfo>
      </MediaQuery>

      <MediaQuery maxWidth={720}>
        <StyledMobileUserInfo>
          <ProfileAvatar personalId={personalId} title={name} size="small" />
          <div className="column">
            <StyledMobileUserInfoHeader className="page-header flex-wrap column">
              {`${pageTitle} - ${name} `}
            </StyledMobileUserInfoHeader>
            <Subtitle
              title={haveHomeUnit ? homeUnit.title : ""}
              positions={jobPositions ? jobPositions : ""}
            />
          </div>
        </StyledMobileUserInfo>
      </MediaQuery>
    </div>
  );
};

const Subtitle = (props) => {
  const { title = "", manager = "", positions = "" } = props;

  if (!title && !manager && !positions) {
    return null;
  }

  return (
    <h2 className="page-subheader flex flex-wrap">
      {`${title} ${manager} ${positions}`}
    </h2>
  );
};

Comment.UserInfoHeading = {
  personalId: 1,
  name: "",
  jobPositions: "",
  managers: [{}],
  homeUnit: {},
};

export default UserInfoHeading;
